import React, { useState, useEffect } from "react";
import Box from "@mui/material/Box";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import Avatar from "@mui/material/Avatar";
import GlobalSnackbar from "../../../../shared/utils/GlobalSnackbar";
import AddIcon from "@mui/icons-material/Add";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import RecceReport from "../../../RFPDashboard/RecceApproval/RecceReport";
import CapitaliseWords from "../../../../shared/utils/CapitaliseWords";
import CapitalizeFirstLetter from "../../../../shared/utils/CapitalizeFirstLetter";
import PinchIcon from "@mui/icons-material/Pinch";
import GlobalButton from "../../../../shared/utils/GlobalButton";
import {
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  CircularProgress,
  Chip,
} from "@mui/material";
import Pagination from "@mui/material/Pagination";
import axios from "axios";
import Styles from "../../../../styles/vendorDashboard.module.css";
import styles from "../../../../styles/adminPortal.module.css";
import HandymanOutlinedIcon from "@mui/icons-material/HandymanOutlined";
import PdfIcon from "../../../../shared/assets/icons/PdfIcon.png";
import { Link } from "react-router-dom";
import PaymentDialog from "./IpPaymentDialog";
import GlobalDropdownField from "../../../../shared/utils/GlobalDropdownField";

const headCells = [
  {
    id: "campaign",
    label: "Campaign",
    width: 200,
  },

  {
    id: "name",
    label: "IP ",
    width: 200,
  },
  {
    id: "site",
    label: "Site",
    width: 200,
  },
  {
    id: "servicetype",
    label: "Service Type",
    width: 160,
  },
  // {
  //   id: "file",
  //   label: "File",
  //   width: 160,
  // },

  {
    id: "jobdate",
    label: "Job Date",
    width: 140,
  },

  {
    id: "kamapproval",
    label: "Kam Approval",
    width: 160,
  },
  {
    id: "clientapproval",
    label: "Client Approval",
    width: 160,
  },
  {
    id: "action",
    label: "Action",
    width: 160,
  },
];

function EnhancedTableHead(props) {
  return (
    <TableHead className={styles.tableHead}>
      <TableRow>
        {headCells.map((headCell, index) => (
          <TableCell
            key={headCell.id}
            className={styles.tableCell}
            sx={{
              minWidth: headCell.width,
            }}
          >
            <span className={styles.headCellHeading}>{headCell.label} </span>
            <div className={styles.topBorderDiv}>
              {headCell.id === "campaign" && (
                <input
                  type="text"
                  className={styles.searchInput}
                  placeholder="Search Campaign"
                  onChange={(e) =>
                    props.handleSearchChangeHead(e, "campaignTitle")
                  }
                  value={props.searchInputs?.campaignTitle || ""}
                />
              )}
              {headCell.id === "name" && (
                <input
                  type="text"
                  className={styles.searchInput}
                  placeholder="Search IP Name"
                  onChange={(e) => props.handleSearchChangeHead(e, "name")}
                  value={props.searchInputs?.name || ""}
                />
              )}
              {headCell.id === "servicetype" && (
                <GlobalDropdownField
                  variant="searchDropdown"
                  name="serviceTypeFilter"
                  value={props.searchInputs?.serviceType || ""}
                  onChange={(e) =>
                    props.handleSearchChangeHead(e, "serviceType")
                  }
                  placeholder="Select Service Type"
                  options={[
                    { value: "", label: "All" },
                    { value: "0", label: "Recce" },
                    { value: "1", label: "Installation" },
                  ]}
                  renderValueFn={(selected) => {
                    const labels = {
                      "": "All",
                      0: "Recce",
                      1: "Installation",
                    };
                    return (
                      <span
                        style={{
                          color: selected
                            ? "var(--heading-color)"
                            : "var(--listdown-color)",
                        }}
                      >
                        {labels[selected] || "Select Service Type"}
                      </span>
                    );
                  }}
                />
              )}
              {headCell.id === "kamapproval" && (
                <GlobalDropdownField
                  variant="searchDropdown"
                  name="adminStatus"
                  value={props.searchInputs?.adminStatus || ""}
                  onChange={(e) =>
                    props.handleSearchChangeHead(e, "adminStatus")
                  }
                  placeholder="Select KAM Status"
                  options={[
                    { value: "", label: "All" },
                    { value: "1", label: "Approved" },
                    { value: "-1", label: "Rejected" },
                    { value: "0", label: "Pending" },
                  ]}
                  renderValueFn={(selected) => {
                    const labelMap = {
                      "": "All",
                      1: "Approved",
                      "-1": "Rejected",
                      0: "Pending",
                    };

                    return (
                      <span
                        style={{
                          color: selected
                            ? "var(--heading-color)"
                            : "var(--listdown-color)",
                        }}
                      >
                        {labelMap[selected] || "Select KAM Status"}
                      </span>
                    );
                  }}
                  menuProps={{
                    PaperProps: {
                      sx: {
                        fontSize: "0.8rem",
                        fontWeight: "400",
                        maxWidth: "7rem",
                      },
                    },
                  }}
                />
              )}
              {headCell.id === "clientapproval" && (
                <GlobalDropdownField
                  variant="searchDropdown"
                  name="clientStatus"
                  value={props.searchInputs?.clientStatus || ""}
                  onChange={(e) =>
                    props.handleSearchChangeHead(e, "clientStatus")
                  }
                  placeholder="Select Client Status"
                  options={[
                    { value: "", label: "All" },
                    { value: "1", label: "Approved" },
                    { value: "-1", label: "Rejected" },
                    { value: "0", label: "Pending" },
                  ]}
                  renderValueFn={(selected) => {
                    const labelMap = {
                      "": "All",
                      1: "Approved",
                      "-1": "Rejected",
                      0: "Pending",
                    };

                    return (
                      <span
                        style={{
                          color: selected
                            ? "var(--heading-color)"
                            : "var(--listdown-color)",
                        }}
                      >
                        {labelMap[selected] || "Select Client Status"}
                      </span>
                    );
                  }}
                  menuProps={{
                    PaperProps: {
                      sx: {
                        fontSize: "0.8rem",
                        fontWeight: "400",
                        maxWidth: "7rem",
                      },
                    },
                  }}
                />
              )}
            </div>
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}
export default function EnhancedTable({ onPendingPaymentsUpdate }) {
  // Declare states
  const [pageSize, setPageSize] = useState(20);
  const pageSizeOptions = [1, 5, 10, 20, 50, 100];
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [open, setOpen] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const [installationPartner, setInstallationPartner] = useState([]);
  const [installationPartnerListLoading, setInstallationPartnerLoading] =
    useState(true);
  const [currentApproval, setCurrentApproval] = useState(null);
  const [modalOpen, setModalOpen] = useState(false);

  const [searchInputs, setSearchInputs] = useState({
    name: "",
    clientStatus: "",
    adminStatus: "",
    campaignTitle: "",
    serviceType: "",
  });
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "info",
  });

  const serverURL = process.env.REACT_APP_URL;

  const [timelineJobId, setTimelineJobId] = useState(null);

  const handleOpen = (rowData) => {
    setSelectedRow(rowData);
    setTimelineJobId(rowData?.jobId?._id);
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    setSelectedRow(null);
  };

  const handleSnackbarClose = () => {
    setSnackbar({ ...snackbar, open: false });
  };

  const handleReportOpen = (approval) => {
    setCurrentApproval(approval);
    setTimelineJobId(approval?.jobId?._id);

    setModalOpen(true);
  };

  const handleReportClose = () => {
    setModalOpen(false);
    setCurrentApproval(null);
  };

  const getInstallationPartnerPaymentList = async (page = 1, limit = 20) => {
    try {
      const token = localStorage.getItem("token");
      const response = await axios.get(
        `${serverURL}/installationPartnerPayments/viewAll?page=${page}&limit=${limit}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        },
      );
      if (response?.data?.success) {
        setInstallationPartner(response?.data?.data);
        setTotalPages(response?.data?.totalPages);
        // Send pendingPayments to parent
        onPendingPaymentsUpdate(response?.data?.pendingPayments, "ip");
        setInstallationPartnerLoading(false);
      }
    } catch (error) {
      console.error("Error fetching InstallationPartner:", error);
    }
  };
  // Callback function to update pendingPayments

  useEffect(() => {
    getInstallationPartnerPaymentList(page, pageSize);
  }, []);

  const handlePageChange = async (e, value) => {
    setPage(value); // Update the page state

    const queryParams = new URLSearchParams();

    Object.entries(searchInputs).forEach(([key, searchValue]) => {
      if (searchValue.trim() !== "") {
        queryParams.append(key, searchValue);
      }
    });

    queryParams.append("page", value);
    queryParams.append("limit", pageSize);
    await fetchIps(queryParams.toString());
  };

  const handlePageSizeChange = async (e) => {
    const newSize = parseInt(e.target.value, 10);
    setPageSize(newSize);

    const queryParams = new URLSearchParams();

    Object.entries(searchInputs).forEach(([key, searchValue]) => {
      if (searchValue.trim() !== "") {
        queryParams.append(key, searchValue);
      }
    });

    queryParams.append("page", 1);
    queryParams.append("limit", newSize);
    await fetchIps(queryParams.toString());
  };

  const fetchIps = async (queryParams) => {
    console.log(queryParams);
    try {
      const token = localStorage.getItem("token");
      const response = await axios.get(
        `${serverURL}/installationPartnerPayments/viewAll?${queryParams}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        },
      );

      if (response?.data?.success) {
        setInstallationPartner(response?.data?.data);
        setTotalPages(response?.data?.totalPages);
        setPage(response?.data?.currentPage);
      }
    } catch (error) {
      console.error("Error fetching filtered vendors:", error);
    }
  };

  const handleSearchChangeHead = async (e, key) => {
    const value = e.target.value;

    setSearchInputs((prevState) => {
      const updatedInputs = { ...prevState, [key]: value };

      const allFieldsEmpty = Object.values(updatedInputs).every(
        (val) => val === "",
      );

      if (allFieldsEmpty) {
        getInstallationPartnerPaymentList(1, pageSize);
        return updatedInputs;
      }

      let queryParams = new URLSearchParams();

      Object.entries(updatedInputs).forEach(([searchKey, searchValue]) => {
        if (searchValue !== "") {
          queryParams.append(searchKey, searchValue);
        }
      });

      queryParams.append("page", 1);
      queryParams.append("limit", pageSize);
      fetchIps(queryParams.toString());
      return updatedInputs;
    });
  };

  return (
    <div className="bg-white h-full">
      <Box>
        {!installationPartnerListLoading ? (
          <Paper
            sx={{ width: "100%", boxShadow: "none" }}
            className={styles.tableGap}
          >
            <>
              <TableContainer
                className={`${styles.tableContainer} ${Styles["custom-scrollbar"]}`}
              >
                <Table stickyHeader className="rounded-lg">
                  <EnhancedTableHead
                    rowCount={installationPartner?.length}
                    userListData={getInstallationPartnerPaymentList}
                    setSearchInputs={setSearchInputs}
                    handleSearchChangeHead={handleSearchChangeHead}
                    searchInputs={searchInputs}
                  />
                  {installationPartner && installationPartner?.length > 0 ? (
                    <TableBody>
                      {installationPartner.map((v, index) => {
                        return (
                          <TableRow
                            hover
                            className={styles.tableRowHead}
                            tabIndex={-1}
                            key={v._id}
                          >
                            <TableCell className={styles.tableRow}>
                              <div className="text-gray-500 text-xs m-2">
                                {CapitaliseWords(
                                  v?.jobId?.campaignId?.campaignTitle,
                                )}
                              </div>
                            </TableCell>
                            <TableCell className={styles.tableRow}>
                              <div className="flex justify-start items-center ml-2">
                                <Avatar
                                  style={{
                                    background: "#e8f1ff",
                                    color: "#1488ef",
                                  }}
                                  variant="rounded"
                                  sx={{ width: 32, height: 32 }}
                                >
                                  <span className="text-sm">
                                    {v?.installationPartnerId?.name
                                      ? v.installationPartnerId.name
                                          .charAt(0)
                                          .toUpperCase()
                                      : "N"}
                                  </span>
                                </Avatar>
                                <div>
                                  <div className="text-gray-500 font-bold ml-2 text-sm">
                                    {CapitaliseWords(
                                      v?.installationPartnerId?.name,
                                    )}
                                  </div>
                                  <div className="text-gray-500 text-xs ml-2">
                                    {v?.installationPartnerId?.phoneNumber ||
                                      "-"}
                                  </div>
                                </div>
                              </div>
                            </TableCell>
                            <TableCell className={styles.tableRow}>
                              {/* <div className="text-gray-500 font-bold ml-2 text-sm mt-2">
                              Singhla Stores
                                </div> */}
                              <div className="text-gray-500 text-xs m-2">
                                {CapitaliseWords(v?.jobId?.address)}
                              </div>
                            </TableCell>
                            <TableCell className={styles.tableRow}>
                              {v?.jobId?.serviceType == "0" ? (
                                <PinchIcon className="mr-2" />
                              ) : (
                                <HandymanOutlinedIcon className="mr-2" />
                              )}
                              {v?.jobId?.serviceType == "0"
                                ? "Recce"
                                : "Installation"}
                              {/* <HandymanOutlinedIcon/> Installation */}
                            </TableCell>
                            {/* <TableCell className={styles.tableRow}>
                             
                              <div
                                className="flex justify-center items-center cursor-pointer"
                                onClick={() => handleReportOpen(v)}
                              >
                                <img
                                  src={PdfIcon}
                                  className="w-6 h-6 transition-transform duration-300 ease-in-out transform hover:scale-125"
                                  alt="PDF Icon"
                                />
                              </div>
                            </TableCell> */}
                            <TableCell className={styles.tableRow}>
                              <span>
                                {v?.jobId?.jobCompletionDate
                                  ? new Date(
                                      v?.jobId?.jobCompletionDate,
                                    ).toLocaleDateString("en-GB")
                                  : "N/A"}
                              </span>
                            </TableCell>

                            <TableCell className={styles.tableRow}>
                              <div className="flex justify-center items-center">
                                <Chip
                                  label={
                                    v?.approvalStatus?.adminStatus == "1"
                                      ? "Approved"
                                      : v?.approvalStatus?.adminStatus == "-1"
                                        ? "Rejected"
                                        : "Pending"
                                  }
                                  sx={{
                                    backgroundColor:
                                      v?.approvalStatus?.adminStatus == "1"
                                        ? "#DDFFD3" // Green for Approved
                                        : v?.approvalStatus?.adminStatus == "-1"
                                          ? "#FFCDD2"
                                          : "#FFD98E",
                                    color:
                                      v?.approvalStatus?.adminStatus == "1"
                                        ? "#358C09"
                                        : v?.approvalStatus?.adminStatus == "-1"
                                          ? "#D32F2F"
                                          : "#C77903",
                                  }}
                                />
                              </div>
                            </TableCell>
                            <TableCell className={styles.tableRow}>
                              <div className="flex justify-center items-center">
                                <Chip
                                  label={
                                    v?.approvalStatus?.clientStatus == "1"
                                      ? "Approved"
                                      : v?.approvalStatus?.clientStatus == "-1"
                                        ? "Rejected"
                                        : v?.approvalStatus?.clientStatus == "0"
                                          ? "Pending"
                                          : "Pending"
                                  }
                                  sx={{
                                    backgroundColor:
                                      v?.approvalStatus?.clientStatus == "1"
                                        ? "#DDFFD3" // Green for Approved
                                        : v?.approvalStatus?.clientStatus ==
                                            "-1"
                                          ? "#FFDFDF" // Red for Disapproved
                                          : "#FFD98E", // Yellow for Pending
                                    color:
                                      v?.approvalStatus?.clientStatus == "1"
                                        ? "#358C09"
                                        : v?.approvalStatus?.clientStatus ==
                                            "-1"
                                          ? "#8C0909"
                                          : "#C77903",
                                  }}
                                />
                              </div>
                            </TableCell>

                            <TableCell className={styles.tableRow}>
                              <GlobalButton
                                variant="primary"
                                size="small"
                                disabled={
                                  !(
                                    !v?.approvalStatus?.clientStatus == "0" &&
                                    v?.approvalStatus?.adminStatus == "1"
                                  )
                                }
                                onClick={() => handleOpen(v)}
                                leftIcon={
                                  <AddIcon style={{ fontSize: "18px" }} />
                                }
                              >
                                {`Payment`}
                              </GlobalButton>
                            </TableCell>
                          </TableRow>
                        );
                      })}
                    </TableBody>
                  ) : (
                    <TableRow>
                      <TableCell
                        colSpan={headCells?.length}
                        sx={{ borderBottom: "none" }}
                      >
                        <div className="flex justify-center items-center h-64">
                          No Installation Partner Payment Found
                        </div>
                      </TableCell>
                    </TableRow>
                  )}
                </Table>
              </TableContainer>
              <hr
                className="mt-2 bg-gray-200 "
                style={{ border: "0.5px solid var(--light-grey-color)" }}
              />
              <div className="flex items-center justify-between ">
                <FormControl
                  variant="standard"
                  size="small"
                  sx={{
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "center",
                    gap: 1,
                    "& .MuiInputBase-root:before": { borderBottom: "none" },
                    "& .MuiInputBase-root:after": { borderBottom: "none" },
                    "& .MuiInputBase-root": { marginTop: 1 }, // 👈 override here
                  }}
                >
                  <InputLabel
                    id="page-size-label"
                    sx={{
                      position: "static",
                      transform: "none",
                      fontSize: "14px",
                      marginRight: "8px",
                      marginTop: "2px",
                    }}
                  >
                    Rows
                  </InputLabel>
                  <Select
                    labelId="page-size-label"
                    value={pageSize}
                    onChange={handlePageSizeChange}
                    label="Rows"
                  >
                    {pageSizeOptions.map((size) => (
                      <MenuItem key={size} value={size}>
                        {size}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
                <GlobalSnackbar
                  snackbar={snackbar}
                  handleClose={handleSnackbarClose}
                />

                <Pagination
                  className="p-2 flex justify-center"
                  count={totalPages}
                  page={page}
                  onChange={handlePageChange}
                  sx={{
                    "& .MuiPaginationItem-root.Mui-selected": {
                      backgroundColor: "#418cff", // Blue background for selected
                      color: "#fff", // White text for selected
                    },
                    "& .MuiPaginationItem-root.Mui-selected:hover": {
                      backgroundColor: "#3366cc", // Darker blue on hover
                    },
                    "& .MuiPaginationItem-root": {
                      "&:hover": {
                        backgroundColor: "#ddd", // Light gray for hovered items
                      },
                    },
                  }}
                />
              </div>
              {open && (
                <PaymentDialog
                  open={open}
                  onClose={handleClose}
                  selectedRow={selectedRow}
                  userListData={getInstallationPartnerPaymentList}
                />
              )}
              <Dialog
                open={modalOpen}
                onClose={handleReportClose}
                maxWidth="lg"
                fullWidth
                className="custom-dialog"
                PaperProps={{
                  className: "custom-dialog-paper",
                }}
              >
                <DialogContent>
                  {currentApproval && (
                    <RecceReport
                      setOpen={setModalOpen}
                      open={modalOpen}
                      timelineJobId={timelineJobId}
                    />
                  )}
                </DialogContent>
              </Dialog>
            </>
          </Paper>
        ) : (
          <div className="flex justify-center items-center h-[85vh]">
            <CircularProgress />
          </div>
        )}
      </Box>
    </div>
  );
}
